module.exports = __webpack_public_path__ + "media/images/front/site-logo-5f40a8df74bb0383bf8a85c6f4eb2c15.svg";